import { useState } from "react";
import blackDeleteIcon from "../assets/black-delete-icon.svg";
import whiteRightIcon from "../assets/white-right-icon.svg";
import saveIcon from "../assets/save-icon.svg";

const QUALIFICATION_OPTIONS = [
  "MBBS",
  "MD",
  "MS",
  "DNB (Diplomate of National Board)",
  "DM",
  "MCh",
  "BDS",
  "MDS",
];

const gridColsClass =
  "grid grid-cols-[0.5fr_1.5fr_1.3fr_2.2fr_1.4fr_0.6fr] xl:gap-x-[16px] 2xl:gap-x-[24px] 3xl:gap-x-[32px] items-start";

const sanitizeField = (field, value) => {
  if (field === "registrationHPRID")
    return value.replace(/[^a-zA-Z0-9\s]/g, "");
  if (field === "doctorsName") return value.replace(/[^a-zA-Z.\s]/g, "");
  if (field === "contactNumber")
    return value.replace(/[^0-9]/g, "").slice(0, 10);
  return value;
};

const maskContactNumber = (value) => {
  if (!value) return "--";
  if (value.length <= 4) return value;
  return `${"x".repeat(value.length - 4)}${value.slice(-4)}`;
};

const QualificationCell = ({ text }) => {
  const [expanded, setExpanded] = useState(true);
  const value = text || "";
  const needsToggle = value.length > 28;
  const display =
    !needsToggle || expanded ? value : `${value.slice(0, 28).trim()}...`;

  return (
    <div className="min-w-0 font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
      {display || "--"}
      {needsToggle && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="ml-[6px] bg-transparent border-none p-0 font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#5AC69F] cursor-pointer"
        >
          {expanded ? "show less" : "show more"}
        </button>
      )}
    </div>
  );
};

const CareTeamDetailsFormAi = () => {
  const [doctors, setDoctors] = useState([]);
  const [doctorName, setDoctorName] = useState("");
  const [registrationId, setRegistrationId] = useState("");
  const [qualification, setQualification] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [isEditMode, setIsEditMode] = useState(true);

  const resetAddForm = () => {
    setDoctorName("");
    setRegistrationId("");
    setQualification("");
    setContactNumber("");
  };

  const handleAdd = () => {
    const trimmedName = doctorName.trim();
    const trimmedRegId = registrationId.trim();
    const trimmedQualification = qualification.trim();
    const trimmedContact = contactNumber.trim();

    if (
      !trimmedName ||
      !trimmedRegId ||
      !trimmedQualification ||
      !trimmedContact
    ) {
      return;
    }

    if (trimmedContact.length !== 10) return;

    setDoctors((prev) => [
      ...prev,
      {
        doctorsName: trimmedName,
        registrationHPRID: trimmedRegId,
        qualification: trimmedQualification,
        contactNumber: trimmedContact,
      },
    ]);
    resetAddForm();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleDelete = (index) => {
    setDoctors((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="flex items-center justify-between gap-3 pt-[30px]">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="relative w-full min-w-0 box-border overflow-hidden h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[18px] flex items-center">
            <input
              type="text"
              placeholder="Doctor Name"
              value={doctorName}
              onChange={(e) =>
                setDoctorName(sanitizeField("doctorsName", e.target.value))
              }
              onKeyDown={handleKeyDown}
              className="w-full min-w-0 bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none shadow-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] placeholder:text-[#8B8B8B]"
            />
          </div>

          <div className="relative w-full min-w-0 box-border overflow-hidden h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[18px] flex items-center">
            <input
              type="text"
              placeholder="Registration ID/ HPR ID"
              value={registrationId}
              onChange={(e) =>
                setRegistrationId(
                  sanitizeField("registrationHPRID", e.target.value),
                )
              }
              onKeyDown={handleKeyDown}
              className="w-full min-w-0 bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none shadow-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] placeholder:text-[#8B8B8B]"
            />
          </div>

          <div className="relative w-full min-w-0 box-border h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
            <select
              value={qualification}
              onChange={(e) => setQualification(e.target.value)}
              className="absolute inset-0 w-full h-full pl-[18px] pr-[40px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
            >
              <option value="" disabled hidden>
                Qualifications
              </option>
              {QUALIFICATION_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                  d="M7 10.5L14 17.5L21 10.5"
                  stroke="#5AC69F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          <div className="relative w-full min-w-0 box-border overflow-hidden h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[18px] flex items-center">
            <input
              type="text"
              inputMode="numeric"
              maxLength={10}
              placeholder="Contact Number"
              value={contactNumber}
              onChange={(e) =>
                setContactNumber(sanitizeField("contactNumber", e.target.value))
              }
              onKeyDown={handleKeyDown}
              className="w-full min-w-0 bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none shadow-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] placeholder:text-[#8B8B8B]"
            />
          </div>
        </div>

        <button
          type="button"
          onClick={handleAdd}
          className="shrink-0 w-[88px] h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
        >
          ADD
        </button>
      </div>
      <div className="pt-[30px]">
        <div className={`${gridColsClass} items-start`}>
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F] whitespace-nowrap">
            Doctor Name
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F] whitespace-nowrap">
            Registration ID
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Qualification
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F] whitespace-nowrap">
            Contact Number
          </div>

          <div className="justify-self-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Action
          </div>
        </div>

        <div className="mt-[34px] flex flex-col gap-y-[34px]">
          {doctors.map((item, index) => (
            <div key={`${item.doctorsName}-${item.registrationHPRID}-${index}`}>
              <div className={gridColsClass}>
                <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                  {index + 1}.
                </div>

                <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000] whitespace-nowrap">
                  {item.doctorsName || "--"}
                </div>

                <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                  {item.registrationHPRID || "--"}
                </div>

                <QualificationCell text={item.qualification} />

                <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000] whitespace-nowrap">
                  {maskContactNumber(item.contactNumber)}
                </div>

                <button
                  type="button"
                  onClick={() => handleDelete(index)}
                  className="flex items-center justify-self-center bg-transparent border-none cursor-pointer"
                >
                  <img src={blackDeleteIcon} alt="delete icon" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end items-center gap-[10px] mt-[40px]">
        {isEditMode ? (
          <button
            type="button"
            onClick={() => setIsEditMode(false)}
            className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px] 2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal"
          >
            SAVE
            <img src={saveIcon} alt="save" className="pl-[16px]" />
          </button>
        ) : (
          <button
            type="button"
            className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal"
          >
            SAVED
            <img src={whiteRightIcon} alt="white icon" />
          </button>
          )}
      </div>
    </div>
  );
};

export default CareTeamDetailsFormAi;
